/**
 *
 */

window.resizeTextarea = (element, minHeight = 100) => {
    let height = minHeight;
    /**
     *
     * @param element
     */
    let resizeArea = (element) => {
        $(element).css('height', '100px');
        if (element.scrollHeight > minHeight) {
            height = element.scrollHeight;
        }
        $(element).css('height', height + 'px');
    }

    /**
     *
     */
    $(element).on('change blur', () => {
        resizeArea(element);
    });

    resizeArea(element);
}
